import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LiveEventViewModel, ActiveUserViewModel, UserAuthenticationViewModel, ExhibitDesignerViewModel, ActiveExhibitUserViewModel, ActivePosterUserViewModel, PosterViewModel } from 'src/app/_models/generatedModels';
import { HubConnection } from '@microsoft/signalr';
import { EventService, LiveEventService, ExhibitService, PosterService } from 'src/app/_services/generatedServices';
import { EventRole } from 'src/app/_models/models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ToasterService } from 'src/app/_services/toaster.service';

@Component({
  selector: 'poster-visitor-log',
  templateUrl: 'poster-visitor-log.component.html',
})
export class PosterVisitorLogComponent implements OnInit {
  initialized = false;
  @Input() poster: PosterViewModel;
  @Input() connection: HubConnection;
  public EventRole = EventRole;
  @Output()
  closed = new EventEmitter();

  @Output()
  usersUpdated = new EventEmitter<ActivePosterUserViewModel[]>();

  activeUsers: ActivePosterUserViewModel[];
  user: UserAuthenticationViewModel;

  active:boolean = true;

  constructor(private eventService: LiveEventService, private posterService: PosterService, public auth: AuthenticationService, private toaster: ToasterService) {}

  ngOnInit(): void {
    this.user = this.auth.getUser();
    this.activeUsers = [];
    this.initSignalR();
    this.getActiveUsers();
    this.initialized = true;
  }

  getActiveUsers() {
    this.posterService.getActiveUsers(this.poster.id).subscribe((activeUsers) => {
      this.activeUsers = activeUsers;
      this.usersUpdated.emit(activeUsers);
      // activeUsers.forEach((user) => {
      //   this.mergeUser(user);
      // });
    });
  }

  initSignalR() {
    this.connection.on('userDisconnected', (posterId: number, user: ActivePosterUserViewModel) => {
      if (posterId !== this.poster.id) {
        return;
      }
      this.mergeUser(user);
    });

    this.connection.on('userConnected', (posterId: number, user: ActivePosterUserViewModel) => {
      if (posterId !== this.poster.id) {
        return;
      }
      this.getActiveUsers();
    });

    this.connection.on('activeUserUpdated', (posterId: number, user: ActivePosterUserViewModel) => {
      if (posterId !== this.poster.id) {
        return;
      }
      this.mergeUser(user);
    });
  }

  mergeUser(user: ActivePosterUserViewModel) {
    let index = this.activeUsers.findIndex((x) => x.id === user.id);
    if (index === -1) {
      this.activeUsers.push(user);
    } else {
      this.activeUsers[index] = user;
    }
  }

  close() {
    this.closed.emit();
  }
}
